import "./utility-tools.css";
import { rgbToHex } from "./utility-tools-core.js";

const root = document.querySelector("[data-rgb-to-hex]");
if (root) {
  const red = document.getElementById("rgbRed");
  const green = document.getElementById("rgbGreen");
  const blue = document.getElementById("rgbBlue");
  const result = document.getElementById("hexResult");
  const preview = document.getElementById("rgbPreview");
  const status = document.getElementById("rgbStatus");
  const announcement = document.getElementById("rgbAnnouncement");

  const update = () => {
    try {
      const hex = rgbToHex(red.valueAsNumber, green.valueAsNumber, blue.valueAsNumber);
      result.value = hex;
      preview.style.background = hex;
      preview.setAttribute("aria-label", `Color preview ${hex}`);
      announcement.textContent = `RGB ${red.valueAsNumber}, ${green.valueAsNumber}, ${blue.valueAsNumber}`;
      status.hidden = true;
    } catch (error) {
      status.textContent = error.message;
      status.hidden = false;
    }
  };
  for (const input of [red, green, blue]) input.addEventListener("input", update);
  document.getElementById("copyHex").addEventListener("click", async () => {
    await navigator.clipboard.writeText(result.value);
    announcement.textContent = `${result.value} copied.`;
  });
  update();
}
